/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {WinPresentationController} from "../WinPresentationController";
import {gsap} from "gsap";
import {RockBottom} from "../../RockBottom";

export class BreakBankController extends WinPresentationController {

    constructor() {
        super("BreakBankController", false);
    }

    protected hasWin(): boolean {
        return RockBottom.model.parsedGameData.mode === "WINCAP_PICK" && RockBottom.model.parsedGameData.capWinMultiplier > 1;
    }

    protected async createWinAnimation(): Promise<any> {
        const tl = gsap.timeline();
        await new Promise<void>(resolve => {
            RockBottom.winCapScreen.showAnimation(() => {
                RockBottom.keypadPlugin.setZeroBetSpinCounter(-1);
                if (RockBottom.model.parsedGameData.numberOfFreespinsPlayed === 0) {
                    RockBottom.initialCountUp.showToggleWinAmountNWays(RockBottom.model.parsedGameData.totalWin, 0, false)
                }
                resolve();
            });
        });
    }
}